
// TODO: Validate with Max in back end
enum Incapacity {

    WORK_ACCIDENT = 1,
    ILLNESS = 0
}

export default Incapacity;